
export const DASHBOARD_INDICATOR_ATTEMPT = "DASHBOARD_INDICATOR_ATTEMPT";
export const DASHBOARD_INDICATOR_SUCCESS = "DASHBOARD_INDICATOR_SUCCESS";
export const DASHBOARD_INDICATOR_FAILED = "DASHBOARD_INDICATOR_FAILED";
////////////////////////


////////////////////////
export const DASHBOARD_INVOICE_ATTEMPT = "DASHBOARD_INVOICE_ATTEMPT";
export const DASHBOARD_INVOICE_SUCCESS = "DASHBOARD_INVOICE_SUCCESS";
export const DASHBOARD_INVOICE_FAILED = "DASHBOARD_INVOICE_FAILED";




